import React, {useState} from "react";
import Theme from "../utils/CheckTheme";
import ThemeToggler from "../component/ThemeToggler";

export const ThemeContext = React.createContext(Theme())

export default function Landing(props) {
  const [theme, setTheme] = useState(Theme() || "dark")

  return (
      <ThemeContext.Provider value={theme}>
        <ThemeToggler parentCallback={(e) => setTheme(e)}/>
        {props.children}
      </ThemeContext.Provider>
  )
}
